import { useState } from "react";
import { api } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { toast } from "sonner";
import RollPrivacyControl from "./RollPrivacyControl";

const QUICK = ["1d20+0", "2d6+3", "1d8+4", "1d4", "4d6"];

export default function GenericDiceRoller({ gameId, characterId, isGm, members, myMemberId }) {
  const [formula, setFormula] = useState("1d20+0");
  const [rollPrivacy, setRollPrivacy] = useState({ is_private: false, whisper_target_member_id: null });

  const roll = async (f) => {
    try {
      await api.post(`/characters/${characterId}/paper-roll`, {
        game_id: gameId, die: f, bonuses: [], label: `Formula ${f}`,
        is_private: rollPrivacy.is_private, whisper_target_member_id: rollPrivacy.whisper_target_member_id,
      });
      if (rollPrivacy.whisper_target_member_id) {
        const targetName = (members || []).find((m) => m.id === rollPrivacy.whisper_target_member_id)?.display_name || "player";
        toast.success(`Rolled secretly — only you and ${targetName} can see this`);
      } else if (rollPrivacy.is_private) {
        toast.success(isGm ? "Rolled privately — only you can see this" : "Rolled privately — only you and the GM can see this");
      }
    } catch {
      toast.error("Could not roll — create a character first");
    }
  };

  return (
    <div className="p-6 h-full flex flex-col gap-6" data-testid="generic-dice-roller">
      <div>
        <h2 className="font-display text-3xl mb-2">Formula Roller</h2>
        <p className="text-sm text-[#f1e0c5]/50">Roll anything: 2d6+3, 1d20+7, whatever the table needs.</p>
      </div>
      <RollPrivacyControl isGm={isGm} members={members} myMemberId={myMemberId} value={rollPrivacy} onChange={setRollPrivacy} />
      <div className="flex gap-2">
        <Input data-testid="dice-formula-input" value={formula} onChange={(e) => setFormula(e.target.value)} className="bg-black/30 border-white/10 font-mono-sheet text-lg" />
        <Button data-testid="dice-roll-button" onClick={() => roll(formula)} className="rounded-full bg-[#D90429] hover:bg-[#b8031f] px-6">
          Roll
        </Button>
      </div>
      <div className="flex flex-wrap gap-2">
        {QUICK.map((q) => (
          <button
            key={q}
            data-testid={`dice-quick-${q}`}
            onClick={() => {
              setFormula(q);
              roll(q);
            }}
            className="px-4 py-2 rounded-full bg-black/30 border border-white/10 text-sm hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors duration-200"
          >
            {q}
          </button>
        ))}
      </div>
      <p className="text-xs text-[#f1e0c5]/30 mt-auto">Results post straight to the Chat tab with a full breakdown.</p>
    </div>
  );
}
